import * as React from "react";
import { TabContentsProps } from "./typings";
import { BlossomComponents } from "components/flexFramework/BlossomComponents/BlossomComponents";

export const TabContents = ({ blossomComponent, context }: TabContentsProps) => (
  <BlossomComponents blossomComponent={blossomComponent} context={context} />
);

export default TabContents;
